import axios from "axios";

export default class screenshots {
  constructor() {
    this.API_LINK = process.env.VUE_APP_API_LINK;
  }

  async getScreenshots(queries) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/users/screenshot/cms`,
        data: queries
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async downloadScreenshotsTable(queries) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/users/screenshot/cms`,
        data: queries
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}
